import { useEffect, useState } from "react";

const BREAKPOINT_MD = 900; // совпадает с MUI md

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < BREAKPOINT_MD);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${BREAKPOINT_MD - 1}px)`);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isMobile;
}